import { useId } from 'react';

export type ToggleButton = {
  variant?: 'greyOutline';
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
  label: string;
  extraClasses?: string;
};

type TProps = {
  value: string;
  selected: boolean;
  onClick: (value: string) => void;
} & ToggleButton;

export const toggleButtonVariantMap = {
  greyOutline: 'fo-toggle-btn btn-check-grey-outline',
};

export const toggleButtonTypographyMap = {
  xs: 'text-2 -medium',
  sm: 'text-2 -medium',
  md: 'text-1 -medium',
  lg: 'text-1 -medium',
  xl: 'text-1 -medium',
  xxl: 'text-1 -medium',
};

export const ToggleRadioButton = ({
  variant = 'greyOutline',
  size = 'md',
  label,
  value,
  selected,
  onClick,
  extraClasses = '',
}: TProps) => {
  const id = useId();
  return (
    <>
      <input
        type="radio"
        className="btn-check"
        id={id}
        value={value}
        checked={selected}
        onChange={() => onClick(value)}
      />
      <label
        className={`${toggleButtonVariantMap[variant]} -${size} btn ${extraClasses}`}
        htmlFor={id}
      >
        <span className={toggleButtonTypographyMap[size]}>{label}</span>
      </label>
    </>
  );
};
